import React from 'react';
import Head from 'next/head';

import { useAppConfigStateContext } from '@edx/contexts/app-config';
import { LandingPage } from '@edx/components/landing';

const profile = {
  name: 'Miki Santamaria',
  imageUrl: '/img/landings/empieza-ahora/empieza_ahora-profile.jpg',
  reproductions: '60m+',
  subscribers: '230k+',
  testimonials: [
    {
      quote:
        'Miki Santamaria es no sólo un bajista magnífico pero es poseedor del don de saber transmitir lo que conoce y les prometo que van a disfrutar mucho aprendiendo de él.',
      name: 'Abraham Laboriel',
      title: 'Bajista de sesión de Michael Jackson, Ray Charles, Lee Ritenour, etc.',
      avatar: '/img/landings/profile/testimonials/abraham_laboriel_testimonial.jpg',
    },
    {
      quote: 'Miki is a phenomenal player! I’m always excited to be in the studio with him.',
      name: 'Phredley Brown',
      title: 'Guitarrista y director musical de Bruno Mars.',
      avatar: '/img/landings/profile/testimonials/phredly_brown_testimonial.jpg',
    },
  ],
  bio:
    '<p>Miki Santamaria es un bajista, productor y docente nacido en Terrassa –Barcelona- en 1985 con una amplísima trayectoria en directo y en estudio.</p>' +
    '<p>Durante su carrera ha tenido el honor de haber podido trabajar junto a músicos, artistas y espectáculos de todo el mundo como Phred Brown (guitarrista de Bruno Mars), Rock of Ages, Burn The Floor o los programas de televisión Operación Triunfo y Bailando Con Las Estrellas...',
  link: '/miki-santamaria',
  socialNetworks: {
    youtube: {
      link: 'https://www.youtube.com/channel/UC6GfpCMvY8hm_8zcyIjuLgw',
      count: '150K',
    },
    facebook: {
      link: 'https://www.facebook.com/mikisantamaria/',
      count: '67K',
    },
    instagram: {
      link: 'https://www.instagram.com/mikisantamaria/',
      count: '29K',
    },
  },
};

const hero = {
  heading: 'Aprende a tocar el bajo con un método moderno y directo.',
  bgImage: {
    large: '/img/landings/empieza-ahora/empieza_ahora-l.jpg',
    medium: '/img/landings/empieza-ahora/empieza_ahora-m.jpg',
    small: '/img/landings/empieza-ahora/empieza_ahora-s.jpg',
  },
  primaryButton: {
    text: 'Empieza ahora',
    link: '/precio?nav=f',
  },
};

export const exampleLessons = [
  {
    label: 'Principiante',
    embedId: 333971804,
    thumbnail: '/img/landings/empieza-ahora/beginner-example-lesson.jpg',
  },
  {
    label: 'Intermedio',
    embedId: 333962825,
    thumbnail: '/img/landings/empieza-ahora/intermediate-example-lesson.jpg',
  },
  {
    label: 'Avanzado',
    embedId: 439511344,
    thumbnail: '/img/landings/empieza-ahora/advanced-example-lesson.jpg',
  },
];

const EmpiezaAhora: React.FC = () => {
  const { projectName } = useAppConfigStateContext();

  return (
    <>
      <Head>
        <title key="title">{projectName}</title>

        <meta name="robots" content="noindex" />
      </Head>

      <LandingPage profile={profile} hero={hero} exampleLessons={exampleLessons} />
    </>
  );
};

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
EmpiezaAhora.navBar = { position: 'absolute', variant: 'transparent' };

export default EmpiezaAhora;
